module.exports = __webpack_public_path__ + "static/media/aerovinum-1.d73d1ec9.jpg";